import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
    DtgTestT02Component
} from "src/app/dtg/test/t02/dtg.test.t02.component";
@Component({
    templateUrl: './dtg.test.t01.component.html'
    ,styleUrls: ["./dtg.test.t01.component.scss"]
    ,providers: []
})
export class DtgTestT01Component implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    listItems:any = [];

    constructor(
        private modalService: NgbModal
    ) {
        
    }

    ngOnInit() {
        for(let a=0;a<20;a++){
            this.listItems.push({
                id:`id-${a}`
                ,carNo:`car${a}`
                ,unitId:`01212345678${a}`
            });
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    // 마커 팝업의 상세보기 버튼
    clickShowDriveHis(event:any){
        let modalRef = this.modalService.open(
            DtgTestT02Component
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                ,windowClass:"modal-dialog-drive-his"
                ,scrollable: false
            }
        );
        modalRef.componentInstance.selectedCarInput = {
            dtgUnitId:"01229522504"
            ,companyId:"2"
            ,companyNm:"서울우유"
            ,dtgCarNo: "경기91바8402"
            ,dtgCarType: "31"
            ,dtgCarTypeNm: "일반화물자동차"
        };

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                
            }
        });
    }
}